import Sentry from 'lib/sentry';

const initialState = {
  sections: {},
  closestCoursesConfig: {
    toggle: false,
    courseType: [],
    timeFrame: [],
    sectionConfig: null,
  },
  closestCourses: [],
  closestTimestamp: null,
};

const getters = {
  getSections: (state) => state.sections,
  getClosestCoursesConfig: (state) => state.closestCoursesConfig,
  getClosestCourses: (state) => state.closestCourses,
  getClosestTimestamp: (state) => state.closestTimestamp,
};

const actions = {
  async fetchSectionByCategory({commit}, {category}) {
    try {
      commit('setAppLoading', true, {root: true});
      const {data: sections} = await this.$api.getDynamicSection({category});
      commit('setSectionCategory', {category, sections});
      return sections;
    } catch (error) {
      commit('setSectionCategory', {category, sections: []});
      Sentry.log('fetchSectionByCategory', error);
    } finally {
      commit('setAppLoading', false, {root: true});
    }
  },

  fetchPrakerjaClosestCoursesConfig({commit, rootState}) {
    if (rootState.dataServer?.config?.closestCourses) {
      commit('setPrakerjaClosestCoursesConfig', rootState.dataServer?.config?.closestCourses);
      return;
    }
    commit('setLoading', {closestCourseConfig: true}, {root: true});

    return this.$api
      .getNeoConfig({id: ['prakerja-kelas-terdekat-config']})
      .then(({data}) => {
        commit('setPrakerjaClosestCoursesConfig', data?.[0]?.data);
      })
      .catch((e) => {
        commit('setError', {closestCourseConfig: true}, {root: true});
        Sentry.log('fetchPrakerjaClosestCoursesConfig', e);
      })
      .finally(() => {
        commit('setLoading', {closestCourseConfig: false}, {root: true});
      });
  },

  async fetchClosestCourses({commit}, {params}) {
    commit('setLoading', {closestCourses: true}, {root: true});
    this.$api
      .getPrakerjaClosestCourses(params)
      .then(({data}) => {
        commit('setPrakerjaClosestCourses', data?.items);
        commit('setPrakerjaClosestTimestamp', data?.closest_timestamp);
      })
      .catch((e) => {
        commit('setError', {closestCourses: true}, {root: true});
        Sentry.log('fetchClosestCourses', e);
      })
      .finally(() => {
        commit('setLoading', {closestCourses: false}, {root: true});
      });
  },
};

const mutations = {
  setSectionCategory(state, {category, sections}) {
    // eslint-disable-next-line no-undef
    Vue.set(state.sections, category, sections);
  },

  setPrakerjaClosestCoursesConfig(state, payload) {
    state.closestCoursesConfig.toggle = payload.kelas_terdekat_toggle || false;
    state.closestCoursesConfig.courseType = payload.course_type || [];
    state.closestCoursesConfig.timeFrame = payload.timeframe_setting || [];
    state.closestCoursesConfig.sectionConfig = payload.section_configs || [];
  },

  setPrakerjaClosestCourses(state, closestCourse) {
    state.closestCourses = closestCourse || [];
  },

  setPrakerjaClosestTimestamp(state, closestTimestamp) {
    state.closestTimestamp = closestTimestamp;
  },
};

export default {
  namespaced: true,
  state: {...initialState},
  getters,
  actions,
  mutations,
};
